module.exports = "<p>\n  admin-customers works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-customers/admin-customers.component.html
// module id = ./src/app/components/admin/admin-customers/admin-customers.component.html
// module chunks = main